<template>
<div class="chapter">
<div class="inner_page">
<h1 class="P_Heading_1"><span>Blurb</span></h1>
<p class="P_Body_Text"><i>He’s dangerous.</i></p>
<p class="P_Body_Text">He came into my life when I was sixteen. Tattooed, ear pierced, ripped jeans and bloody knuckled. That was the day his family moved in next door.</p>
<p class="P_Body_Text">For six years, I’ve watched my bad-boy neighbor, never knowing when he’s going to be there and when he isn’t. Never knowing what he’s doing when he’s absent, only that it’s dangerous.</p>
<p class="P_Body_Text">And then one night I wake to find him in my bed. Naked. Bruised and bleeding. And hard. <i>Really</i> hard.</p>
<p class="P_Body_Text">He wants me. And he knows I want him too. But he’s dangerous. On every freaking level.</p>
<p class="P_Body_Text">Oh boy, this is going to end in pain…</p>
<h2 class="P_Heading_2"><span>Dedication</span></h2>
<p class="P_Body_Text">For Heidi, my earlier riser and coffee drinker.</p>
<h2 class="P_Heading_2"><span>Acknowledgements</span></h2>
<p class="P_Body_Text">Cover art: Valerie Tibbs, Tibbs Design</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0003.vue?3537644e